import { Hourglass } from 'lucide-react';
import { useT } from '../lib/i18n.tsx';

/** Shown when the cohort is younger than the maturity window: its rates will still grow (Q-05). */
export function ImmatureCohortNotice({
  maturity,
}: {
  maturity: { cohortAgeDays: number; maturityWindowDays: number; immature: boolean };
}) {
  const t = useT();
  if (!maturity.immature) return null;
  return (
    <div
      role="note"
      className="flex items-start gap-2 rounded-md border border-warning bg-card p-3 text-sm"
    >
      <Hourglass aria-hidden="true" className="mt-0.5 size-4 shrink-0 text-warning" />
      <div>
        <p className="font-medium">{t.immature.title}</p>
        <p className="text-muted-foreground">
          {t.immature.detail(maturity.cohortAgeDays, maturity.maturityWindowDays)}
        </p>
      </div>
    </div>
  );
}
